import clsx from 'clsx';
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { formatDateWithDateAndMonthName, setItemStatus, getValueFromResource, FormatInvoiceDecimalNumber, } from '../../../common/timeLiveFunction';
import { displayValueForTimeEntry, getTimeFromDecimal } from '../../../common/timesheetFunction';
import moment from 'moment';
import fetchAPI from '../../../common/fetchAPI';
import { Dropdown } from 'react-bootstrap';
import { updateAccountProjectTaskId, updateIsLoading, deleteAccountProjectTask, updateAccountProjectId } from '../TasksSlice';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import AssignedProjectTaskTeam from '../team/AssignedProjectTaskTeam';
import TaskAddAndUpdate from '../projectTask/TaskAddAndUpdate';
import TaskOffCanvas from '../../../common/OffCanvas';
import { resetAttachmentList } from '../../../features/attachment/AttachmentSlice';
import { AttachmentUpload } from '../../../features/attachment/AttachmentUpload';
import GetAttachments from '../../../features/attachment/AttachmentItem';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import Loader from '../../../common/Loader';
import AccountProjectTaskComments from './AccountProjectTaskComments';
import { getParentChildPagePermissionsAsync } from '../../../common/GlobalSlice';
import MoveTask from './MoveTask';

const initialValues = {
    totalHours: '',
    billableHours: '',
    nonBillableHours: '',
    totalCost: '',
    billableAmount: '',
    billableExpense: '',
    projectName: '',
    taskStatus: '',
    taskName: '',
    startDate: '',
    endDate: '',
    projectCode: '',
    projectBillingRateTypeId: 0,
    accountProjectId: 0
}

const initialValuesForPermissions = {
    IsTaskTeam: false,
    IsAddTaskTeam: false,
    IsEditTaskTeam: false,
    IsDeleteTaskTeam: false,
    permissionList: []
}

const AccountProjectTaskSummary = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fromValue = queryParams.get('from');
    // const { state } = useLocation();
    //const { AccountProjectId, AccountProjectTaskId, ProjectCode, ProjectName, Status, StartDate, Deadline, ProjectBillingRateTypeId } = state.obj;
    // local storage work comment
    const storedObjectData = localStorage.getItem('objTask');

    // const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    // const { AccountProjectId, AccountProjectTaskId, ProjectCode, ProjectName, Status, StartDate, Deadline, ProjectBillingRateTypeId } = objectData;
    const { AccountProjectId } = useParams();
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : {};
    const AccountProjectTaskId : any = objectData.AccountProjectTaskId;
    const { IsSummaryFrom } = objectData;
    const [tab, setTab] = useState('Comments');
    const [projectTaskSummary, setProjectTaskSummary] = useState<any | ''>(initialValues);
    const { isLoadingSummary, isReload } = useAppSelector((state) => state.tasks);
    const { cultureInfoName, IsList, IsAdd, IsEdit, IsDelete, isLoading: isLoading_globalState, allowMoveTask,enableUploadFeature, decimalFormat,decimalPlaces } = useAppSelector((state) => state.globalState);
    const { allocationHoursInProjectTaskTeam } = useAppSelector((state) => state.project);
    const Parent_SystemSecurityCategoryPageId: string = "32";
    const [childs, setChilds] = useState(initialValuesForPermissions);
    const moveTaskRef = useRef<any>(null);
    const [moveTaskModal, setMoveTaskModal] = useState(false);
    const [moveProjectTaskId, setMoveProjectTaskId] = useState(0);
    const showItems = fromValue === 'projectTemplateTask'
    const prevIsReload = useRef(isReload);

    useLayoutEffect(() => {
        setProjectTaskSummary({
            ...projectTaskSummary,
            accountProjectId: AccountProjectId
        });
        const fetchPagePermissions = async () => {
            if (Parent_SystemSecurityCategoryPageId && Parent_SystemSecurityCategoryPageId !== '') {
                getPermissions(Parent_SystemSecurityCategoryPageId, "158")
            }
        }
        fetchPagePermissions();
    }, [dispatch]);

    const getPermissions = (SystemSecurityCategoryPageId: string, ChildSystemSecurityCategoryPageIds: string) => {
        dispatch(getParentChildPagePermissionsAsync({ SystemSecurityCategoryPageId: SystemSecurityCategoryPageId, ChildSystemSecurityCategoryPageIds: ChildSystemSecurityCategoryPageIds }))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.ParentPermission) {
                    if (originalPromiseResult.ParentPermission.IsList && originalPromiseResult.ChildPermission) {
                        const childPermission: any = originalPromiseResult.ChildPermission;
                        const isTaskTeam = childPermission.filter((x: any) => x.Id === 158)[0].IsList;
                        const isAddTaskTeam = childPermission.filter((x: any) => x.Id === 158)[0].IsAdd;
                        const isEditTaskTeam = childPermission.filter((x: any) => x.Id === 158)[0].IsEdit;
                        const isDeleteTaskTeam = childPermission.filter((x: any) => x.Id === 158)[0].IsDelete;
                        setChilds({
                            ...childs,
                            IsTaskTeam: isTaskTeam,
                            IsAddTaskTeam: isAddTaskTeam,
                            IsEditTaskTeam: isEditTaskTeam,
                            IsDeleteTaskTeam: isDeleteTaskTeam
                        });
                    }
                    else {
                        navigate('../error/403');
                    }
                }
                else {
                    navigate('../error/403');
                }
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    useEffect(() => {
        renderAccountProjectTaskSummary();
        // setTab('Comments');
        if (IsSummaryFrom === 'attachment') {
            setTab('AttachmentList');
        } else if (IsSummaryFrom === 'team') {
            setTab('TeamList');
        } else {
            setTab('Comments');
        }
    }, []);

    // useEffect(() => {
    //     if (isReload) {
    //         renderAccountProjectTaskSummary();
    //         setTab('Comments');
    //     }
    // }, [isReload]);
    useEffect(() => {
    if (prevIsReload.current !== isReload) {
        prevIsReload.current = isReload;
        renderAccountProjectTaskSummary();
        setTab('Comments');
    }
}, [isReload]);

    useEffect(() => {
        if (moveTaskModal) {
            if (moveTaskRef.current) {
                moveTaskRef.current.click();
            }
        }
    }, [moveTaskModal]);

    //Attachment Work
    const modalAttachmentRef = useRef<any>(null);
    const [tempAttachmentId, setTempAttachmentId] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const attachmentUploadClearRef = useRef<any>(null);
    useEffect(() => {
        if (modalIsOpen) {
            if (modalAttachmentRef.current) {
                modalAttachmentRef.current.click();
            }
        }
    }, [modalIsOpen]);
    const handleAttachment = () => {
        dispatch(resetAttachmentList());
        setModalIsOpen(true);
    }
    const updateTempAttachmentId = (value: any) => {
        setTempAttachmentId(value);
    };
    //Attachment Work

    const renderAccountProjectTaskSummary = async () => {
        try {
            const response = await fetchAPI(`api/V2/Tasks/GetAccountProjectTaskSummary/${AccountProjectId}/${AccountProjectTaskId}`, 'Get', '', true);
            const json = await response.json();
            let totalHours = json["TimeEntryHours"][0];
            let taskSummary = json["AccountProjectTask"][0];
            setProjectTaskSummary({
                ...projectTaskSummary,
                totalHours: totalHours != undefined ? (decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), totalHours.TotalHours, 2) : totalHours.ConvertTotalMinutes) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2),
                billableHours: totalHours != undefined ? totalHours.ConvertBillableTotalMinutes : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2),
                nonBillableHours: totalHours != undefined ? totalHours.ConvertNonBillableTotalMinutes : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2),
                totalCost: FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces),
                billableAmount: FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces),
                billableExpense: FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces),
                projectName: taskSummary.ProjectName,
                taskStatus: taskSummary.TaskStatus,
                taskName: taskSummary.TaskName,
                startDate: taskSummary.StartDate,
                endDate: taskSummary.DeadlineDate,
                projectCode: taskSummary.ProjectCode,
                accountProjectId: taskSummary.AccountProjectId
            });
        } catch (error) {

        }
    }

    const deleteAccountProjectTaskById = (id: number) => {
        let obj = {
            "AccountProjectId": projectTaskSummary.accountProjectId,
            "ProjectCode": projectTaskSummary.projectCode,
            "ProjectName": projectTaskSummary.projectName,
            "Status": projectTaskSummary.taskStatus,
            "StartDate": projectTaskSummary.startDate,
            "Deadline": projectTaskSummary.endDate,
            "ProjectBillingRateTypeId": projectTaskSummary.projectBillingRateTypeId,
            "IsSummaryFrom": 'Task'
        }
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    dispatch(deleteAccountProjectTask(id)).then((result) => {
                        Number(result.payload.id) > 0 && navigate(`/accountprojectsummary/${obj.AccountProjectId}`, { state: { obj } });
                        Number(result.payload.id) > 0 ?
                            ShowToast('Success', 'Account Project Task Delete Successfully!', "success", "toast-top-right") :
                            ShowToast('error', 'Account Project Task Delete Failed!', "error", "toast-top-right");
                    })
                        .catch((error) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    const generalObject = {
        "name": getValueFromResource("Task", dispatch, t),
        "width": "700px",
        "componentName": <TaskAddAndUpdate IsFromSummary={true} />
    }

    const navigateToProjectTaskTeam = (obj: any) => {
        // navigate('/projecttaskteam', { state: { obj } })
        if(fromValue === 'projectTemplateTask'){
            navigate(`/projecttaskteam/${obj.AccountProjectId}/${obj.AccountProjectTaskId}?from=projectTemplateTeam`, { state: { obj } })
        }else{
            navigate(`/projecttaskteam/${obj.AccountProjectId}/${obj.AccountProjectTaskId}`, { state: { obj } })
        }

    }

    const navigateToTaskHoursRequest = (obj: any) => {
        navigate('/taskrequesthours', { state: { obj } });
    }

    const navigateToAudit = (AccountProjectTaskId: any) => {
        const obj = {
            Id: AccountProjectTaskId,
            TableName: 'AccountProjectTask',
            Title: getValueFromResource('Project Task Audit', dispatch, t)
        }
        // navigate('/accountaudit', { state: { obj } });       
        navigate(`/accountaudit/${AccountProjectTaskId}`, { state: { obj } })

    }

    return (
        <>
            {modalIsOpen && (
                <>
                    <div className='modal drawer-overlay' tabIndex={-1} data-bs-backdrop="false" id='attachmentModel' role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content rounded">
                                <div className='modal-header pb-2'>
                                    <h6>
                                        {/* {t(`Attachment`)} */}
                                        {getValueFromResource('Attachment', dispatch, t)}
                                    </h6>
                                    <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={() => setModalIsOpen(false)}>
                                        <KTIcon iconName='cross' className='fs-1' />
                                    </div>
                                </div>
                                <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                                    <AttachmentUpload
                                        Id={Number(AccountProjectTaskId)}
                                        onupdateTempAttachmentId={updateTempAttachmentId}
                                        clearRef={attachmentUploadClearRef}
                                        AccountAttachmentTypeId={5}
                                    />
                                    <GetAttachments Id={Number(AccountProjectTaskId)} AccountAttachmentTypeId={5} IsShowEmployeeInformation={false} />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        data-bs-dismiss="modal"
                                        onClick={() => setModalIsOpen(false)}
                                    >
                                        {/* {t("Cancel")} */}
                                        {/* {getValueFromResource('Cancel', dispatch, t)} */}
                                        {getValueFromResource('Close', dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button ref={modalAttachmentRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#attachmentModel">
                        {/* {t('Launch demo modal')} */}
                        {getValueFromResource('Launch demo modal', dispatch, t)}
                    </button>
                </>
            )}
            {isLoadingSummary || isLoading_globalState && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white dropdown-zindex fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Task Detail')} */}
                        {getValueFromResource('Task Detail', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="btn-group me-2">
                            <button
                                type="button"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i className="fa fa-plus mb-1 me-1"></i>
                                {/* {t('Add')} */}
                                {getValueFromResource('Add ', dispatch, t)}
                                <i className=""></i>
                                <i className="fa fa-angle-down"></i>
                            </button>
                            <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-175px" role="menu">
                                <div className='menu-hover-bg-sec cursor'>
                                    {/* {customMenuList.length > 0 && customMenuList.filter((x: any) => x.Id == 158)[0].IsList && */}
                                    {childs.IsTaskTeam &&
                                        <Dropdown.Item
                                            className="menu-item me-lg-0 custom-menu-item"
                                            onClick={() => {
                                                navigateToProjectTaskTeam({
                                                    "AccountProjectId": projectTaskSummary.accountProjectId,
                                                    "AccountProjectTaskId": AccountProjectTaskId,
                                                    "TaskName": projectTaskSummary.taskName,
                                                    "Status": projectTaskSummary.taskStatus,
                                                    "StartDate": projectTaskSummary.startDate,
                                                    "Deadline": projectTaskSummary.endDate,
                                                    "IsEdit": childs.IsEditTaskTeam
                                                    //"IsEdit": customMenuList.filter((x: any) => x.Id == 158)[0].IsEdit
                                                })
                                            }}
                                        >
                                            <span className="menu-icon custom-menu mb-2">
                                                <i className="bi bi-person-plus fs-4 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title custom-menu-fontsize">
                                                {/* {`${t('Add Team')}`} */}
                                                {getValueFromResource('Add Team', dispatch, t)}
                                            </span>
                                        </Dropdown.Item>
                                    }
                                    {enableUploadFeature &&
                                    <Dropdown.Item
                                        className="menu-item me-lg-0  custom-menu-item"
                                        onClick={(event: any) => {
                                            event.preventDefault();
                                            handleAttachment();
                                        }}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-paperclip fs-4 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Add Attachment')}`} */}
                                            {getValueFromResource('Add Attachment', dispatch, t)}
                                        </span>
                                    </Dropdown.Item>
                                    }
                                </div>
                            </ul>
                        </div>
                        <div className="btn-group">
                            <button
                                type="button"
                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i className="fa fa-cog mb-1 me-1"></i>
                                {/* {t('Options')} */}
                                {getValueFromResource('Options', dispatch, t)}
                                <i className=""></i>
                                <i className="fa fa-angle-down"></i>
                            </button>
                            <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-175px" role="menu">
                                <div className='menu-hover-bg-sec'>
                                    {/* {customMenuList.length > 0 && customMenuList.filter((x: any) => x.Id == 32)[0].IsEdit && */}
                                    {IsEdit &&
                                        <Dropdown.Item
                                            id="kt_OffCanvas"
                                            className="menu-item me-lg-0"
                                            onClick={() => {
                                                dispatch(updateAccountProjectTaskId(AccountProjectTaskId))
                                                dispatch(updateAccountProjectId(projectTaskSummary.accountProjectId))
                                            }}
                                        >
                                            <span className="menu-icon custom-menu mb-2">
                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title custom-menu-fontsize">
                                                {/* {`${t('Edit Task')}`} */}
                                                {getValueFromResource('Edit Task', dispatch, t)}
                                            </span>
                                        </Dropdown.Item>
                                    }
                                    {allowMoveTask &&
                                        <Dropdown.Item
                                            className="menu-item me-lg-0"
                                            onClick={() => {
                                                setMoveProjectTaskId(Number(AccountProjectTaskId));
                                                setMoveTaskModal(true);
                                            }}
                                        >
                                            <span className="menu-icon custom-menu mb-2">
                                                <i className="bi bi-arrows-move fs-4 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title custom-menu-fontsize">
                                                {getValueFromResource('Move Task', dispatch, t)}
                                            </span>
                                        </Dropdown.Item>
                                    }
                                   {!showItems && <Dropdown.Item
                                        id="kt_OffCanvas"
                                        className="menu-item me-lg-0"
                                        onClick={() => {
                                            navigate(`/accountbillingrate/${AccountProjectTaskId}?from=summary`, {
                                                state: {
                                                    "SystemBillingRateTypeId": 4,
                                                    "AccountProjectTaskId": AccountProjectTaskId,
                                                    "ProjectName": projectTaskSummary.projectName,
                                                    "TaskName": projectTaskSummary.taskName
                                                }
                                            })
                                        }}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-currency-exchange fs-4 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Rate History')}`} */}
                                            {getValueFromResource('Rate History', dispatch, t)}
                                        </span>
                                    </Dropdown.Item>}
                                    {!showItems && allocationHoursInProjectTaskTeam &&
                                        <div className='menu-hover-bg-danger'>
                                            <Dropdown.Item
                                                className="menu-item me-lg-0"
                                                onClick={() => {
                                                    navigateToTaskHoursRequest({
                                                        "AccountProjectTaskId": AccountProjectTaskId
                                                    });
                                                }}
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    <i className="bi bi-clock fs-4 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-title custom-menu-fontsize">
                                                    {/* {`${t('Task Hours Request')}`} */}
                                                    {getValueFromResource('Task Hours Request', dispatch, t)}
                                                </span>
                                            </Dropdown.Item>
                                        </div>}
                                    {!showItems && <Dropdown.Item
                                        className="menu-item me-lg-0 "
                                        onClick={() => navigateToAudit(AccountProjectTaskId)}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-receipt fs-6 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Audit')}`} */}
                                            {getValueFromResource('Audit', dispatch, t)}
                                        </span>
                                    </Dropdown.Item>}
                                </div>
                                {/* {customMenuList.length > 0 && customMenuList.filter((x: any) => x.Id == 32)[0].IsDelete && */}
                                {IsDelete &&
                                    <><div className='separator mb-1 mt-1 opacity-75'></div>
                                        <div className='menu-hover-bg-danger'>
                                            <Dropdown.Item
                                                className="menu-item me-lg-0"
                                                onClick={() => { deleteAccountProjectTaskById(Number(AccountProjectTaskId)) }}
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-title delete-menu custom-menu-fontsize">
                                                    {/* {`${t('Delete')}`} */}
                                                    {getValueFromResource('Delete', dispatch, t)}
                                                </span>
                                            </Dropdown.Item>
                                        </div>
                                    </>
                                }

                            </ul>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-9'>
                        <div className='mt-4'>
                            <div className="d-flex align-items-center mt-2 mb-1">
                                <a className="text-muted fw-bold me-2 fs-2">{projectTaskSummary.taskName}</a>
                            </div>
                            <div className="breadcrumb breadcrumb-separatorless fs-7 my-0">
                                <a className="text-gray-500 fs-8">
                                    {/* {t("Project Name")} */}
                                    {getValueFromResource('Project Name', dispatch, t)}
                                </a>
                                <span className="breadcrumb-item"><span className="bullet bg-gray-400 w-5px h-2px"></span></span>
                                <span className="breadcrumb-item text-muted me-2 fs-6">{projectTaskSummary.projectName}</span>
                            </div>
                            <div className="d-flex flex-wrap fs-7 mb-4 pe-2">
                                <a className="text-gray-500">
                                    <i className="bi bi-calendar fs-6 iconColor me-2"></i>
                                    {/* {`${moment.parseZone(projectTaskSummary.startDate).format('DD MMM yy')} - ${moment.parseZone(projectTaskSummary.endDate).format('DD MMM yy')}`} */}
                                    {formatDateWithDateAndMonthName(projectTaskSummary.startDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(projectTaskSummary.endDate, cultureInfoName.toString())}
                                </a>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(projectTaskSummary.taskStatus))} style={{ lineHeight: 0.8, marginLeft: 4 }}>
                                    {projectTaskSummary.taskStatus}
                                </span>
                            </div>
                        </div>
                        <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-6' role='tablist'>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Comments' })}
                                    onClick={() => setTab('Comments')}
                                    role='tab'
                                >
                                    {/* {t("Comments")} */}
                                    {getValueFromResource('Comments', dispatch, t)}
                                </a>
                            </li>
                            {/* {customMenuList.length > 0 && customMenuList.filter((x: any) => x.Id == 158)[0].IsList &&  */}
                            {childs.IsTaskTeam &&
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'TeamList' })}
                                        onClick={() => setTab('TeamList')}
                                        role='tab'
                                    >
                                        {/* {t("Team")} */}
                                        {getValueFromResource('Team', dispatch, t)}
                                    </a>
                                </li>}
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'AttachmentList' })}
                                    onClick={() => setTab('AttachmentList')}
                                    role='tab'
                                >
                                    {/* {t("Attachment")} */}
                                    {getValueFromResource('Attachment', dispatch, t)}
                                </a>
                            </li>
                        </ul>
                        <div className='tab-content pt-0'>
                            {/* <div className={clsx('tab-pane', { active: tab === 'Comments' })}>
                                {tab === 'Comments' && <AccountProjectTaskComments AccountProjectTaskId={AccountProjectTaskId} />}
                            </div> */}
                            <div className={clsx('tab-pane', { active: tab === 'Comments' })}
                                style={{ display: tab === 'Comments' ? 'block' : 'none' }}>
                                <AccountProjectTaskComments AccountProjectTaskId={AccountProjectTaskId} />
                            </div>
                            {/* {customMenuList.length > 0 && customMenuList.filter((x: any) => x.Id == 158)[0].IsList &&  */}
                            {childs.IsTaskTeam &&
                                <div className={clsx('tab-pane', { active: tab === 'TeamList' })}>
                                    {tab === 'TeamList' && <AssignedProjectTaskTeam AccountProjectTaskId={AccountProjectTaskId} />}
                                </div>}
                            <div className={clsx('tab-pane', { active: tab === 'AttachmentList' })}>
                                {tab === 'AttachmentList' && <GetAttachments Id={Number(AccountProjectTaskId)} AccountAttachmentTypeId={5} IsShowEmployeeInformation={false} />}
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className="d-flex align-items-center mt-5 mb-3">
                            <a className="text-muted fs-6 fw-bold me-2">
                                {getValueFromResource('Task Summary', dispatch, t)}
                            </a>
                        </div>
                        <div className='col-md-12 col-sm-12 col-xs-12'>
                            <div className='cardInfoShadow mt-3' style={{ height: 132, overflow: 'hidden' }}>
                                <div className='tsNavBarInnerBoxParent' style={{ marginLeft: "2px" }}>
                                    <div className='tsNavBarInnerBoxSecondSection' style={{ left: 8, top: 10 }}>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText">{projectTaskSummary.totalHours}</span>
                                        <a className="text-uppercase tsNavBarInfoLabel">
                                            {getValueFromResource('Total Hours', dispatch, t)}
                                        </a>
                                    </div>
                                </div>

                                <div style={{ borderBottom: "2px solid #f4f4f4", margin: "6% 3%" }}></div>
                                <div style={{ display: 'flex', marginLeft: "10px", marginTop: '20px' }}>
                                    <div style={{ flex: '0 0 33.33%' }}>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText" style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {projectTaskSummary.totalCost}
                                        </span>
                                        <span className="text-uppercase tsNavBarInfoLabel" style={{
                                            display: 'block',
                                            whiteSpace: 'normal',
                                            overflow: 'hidden',
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word'
                                        }}>
                                            {getValueFromResource('TOTAL COST', dispatch, t)}
                                        </span>
                                    </div>
                                    <div style={{
                                        flex: '0 0 33.33%',
                                        borderLeft: '2px solid #c6c6c7',
                                        paddingLeft: '8px',
                                        paddingRight: '4px'
                                    }}>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText" style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {projectTaskSummary.billableAmount}
                                        </span>
                                        <span className="text-uppercase tsNavBarInfoLabel" style={{
                                            display: 'block',
                                            whiteSpace: 'normal',
                                            overflow: 'hidden',
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word'
                                        }}>
                                            {getValueFromResource('Employee Cost', dispatch, t)}
                                        </span>
                                    </div>

                                    <div style={{
                                        flex: '0 0 33.33%',
                                        borderLeft: '2px solid #c6c6c7',
                                        paddingLeft: '8px'
                                    }}>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText" style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {projectTaskSummary.billableExpense}
                                        </span>
                                        <span className="text-uppercase tsNavBarInfoLabel" style={{
                                            display: 'block',
                                            whiteSpace: 'normal',
                                            overflow: 'hidden',
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word'
                                        }}>
                                            {getValueFromResource('EXPENSES', dispatch, t)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <TaskOffCanvas obj={generalObject} />
            {moveTaskModal && (
                <>
                    <MoveTask
                        isOpen={moveTaskModal}
                        accountProjectTaskId={moveProjectTaskId}
                        accountProjectTaskName={projectTaskSummary.taskName}
                        projectName={projectTaskSummary.projectName}
                        closeModal={() => setMoveTaskModal(false)}
                    />
                    <button ref={moveTaskRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#attendanceModal">
                        {getValueFromResource('Launch demo modal', dispatch, t)}
                    </button>
                </>
            )}
        </>
    )
}
export default AccountProjectTaskSummary